"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _grid = require("@rebass/grid");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _getRelevantTime = require("../utils/getRelevantTime");
var __jsx = _react.default.createElement;
const OperatingHoursRow = ({
  weekdate,
  times
}) => {
  const intl = (0, _reactIntl.useIntl)();
  return __jsx(Container, null, __jsx(_grid.Box, null, __jsx(_Body.default, {
    style: {
      textTransform: 'capitalize',
      fontWeight: 600
    }
  }, __jsx(_reactIntl.FormattedDate, {
    value: weekdate,
    format: "WEEKDAY"
  }), ":")), __jsx(_grid.Box, null, !times.length && __jsx(_Body.default, null, __jsx(_reactIntl.FormattedMessage, {
    id: "6DKj3d",
    defaultMessage: [{
      "type": 0,
      "value": "gesloten"
    }]
  })), times.map(({
    timeOpen,
    timeClosed
  }, i) => __jsx(_Body.default, {
    key: i
  }, timeOpen === '00:00' && timeClosed === '23:59' ? intl.formatMessage(_getRelevantTime.alwaysOpenMessage) : __jsx(_react.default.Fragment, null, timeOpen, " - ", timeClosed, " ", __jsx(_reactIntl.FormattedMessage, {
    id: "ViGBFO",
    defaultMessage: [{
      "type": 0,
      "value": "uur"
    }]
  }))))));
};
var _default = exports.default = OperatingHoursRow;
const Container = _styledComponents.default.div.withConfig({
  displayName: "OperatingHoursRow__Container",
  componentId: "cobt22-0"
})(["display:flex;justify-content:space-between;@media screen and (min-width:", "){max-width:34rem;justify-content:unset;> div{flex:1;}}"], ({
  theme
}) => theme.mediaQueries.s);